import React, { createContext, useContext, useMemo } from 'react';

const CommunityBadgesContext = createContext({});

export const useCommunityBadges = () => useContext(CommunityBadgesContext);

export const CommunityBadgesProvider = ({ communityBudges = {}, children }) => {
    const value = useMemo(() => communityBudges, [communityBudges]);
    return (
        <CommunityBadgesContext.Provider value={value}>
            {children}
        </CommunityBadgesContext.Provider>
    );
};
